// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"9732fb9e","110":"788a1ac4","218":"e5f8add7","869":"dbbdaaf5","953":"b38836c1"}[chunkId] + ".chunk.css";
};